import React from 'react';
import { DeviceProvider } from './DeviceProvider.jsx';
import { SessionProvider } from './SessionProvider.jsx';
import { AccessProvider } from './AccessProvider.jsx';
import { ProgressSyncProvider } from './ProgressSyncProvider.jsx';
import { CatalogProvider } from './CatalogProvider.jsx';
import { ConsentProvider } from './ConsentProvider.jsx';
import { AppErrorBoundary } from '../errors/AppErrorBoundary.jsx';

export function AppProviders({ children }) {
  return (
    <AppErrorBoundary>
      <ConsentProvider>
        <DeviceProvider>
          <SessionProvider>
            <AccessProvider>
              <ProgressSyncProvider>
                <CatalogProvider>{children}</CatalogProvider>
              </ProgressSyncProvider>
            </AccessProvider>
          </SessionProvider>
        </DeviceProvider>
      </ConsentProvider>
    </AppErrorBoundary>
  );
}
